/**
 * @description 格式化列表数据 -- 数据字典转换
 * @param {*} data
 */
const formatTotalDataList = (data, dictData) => {
    if (!data.length) return [];
    data.forEach((item) => {
        item.arrivalStatusName = item.arrivalStatus === '00' ? '已抵达' : '未抵达';
        item.stationArrivalWayName = dictData.OTP_STATION_ARRIVAL_WAY[item.stationArrivalWay];
    });
    return data;
};
export { formatTotalDataList };
